var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPictoOffice(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .prefix__cls-2{fill:none;stroke:#898e9a;stroke-linecap:round;stroke-miterlimit:10}\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "prefix__pict-bureau",
    transform: "translate(-12 -11)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "prefix__Rectangle_359",
    width: 48,
    height: 48,
    fill: "none",
    "data-name": "Rectangle 359",
    rx: 2,
    transform: "translate(12 11)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "prefix__ico-bureaux",
    transform: "translate(17 16)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "prefix__Trac\\xE9_135",
    d: "M339.235 534.33v-17.15a1.859 1.859 0 0 1 1.859-1.859h34.593a1.859 1.859 0 0 1 1.859 1.859v17.15",
    className: "prefix__cls-2",
    "data-name": "Trac\\xE9 135",
    transform: "translate(-339.235 -496.139)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Ligne_34",
    d: "M0 0L38.311 0",
    className: "prefix__cls-2",
    "data-name": "Ligne 34",
    transform: "translate(0 26.933)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "prefix__Rectangle_52",
    width: 19.359,
    height: 12.815,
    className: "prefix__cls-2",
    "data-name": "Rectangle 52",
    rx: 2.922,
    transform: "translate(.74 2.366)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Ligne_35",
    d: "M0 0L0 4.001",
    className: "prefix__cls-2",
    "data-name": "Ligne 35",
    transform: "translate(8.768 15.181)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "prefix__Groupe_89",
    "data-name": "Groupe 89",
    transform: "translate(20.352)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "prefix__Trac\\xE9_136",
    d: "M381.84 510.511c2.918-1.081 3.2-2.849 2.768-3.977s-.826-1.888-1.6-3.5-2.044-2.4-5.122-2.4H374.9c-3.077 0-4.345.789-5.122 2.4",
    className: "prefix__cls-2",
    "data-name": "Trac\\xE9 136",
    transform: "translate(-369.781 -491.237)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_14",
    cx: 4.041,
    cy: 4.041,
    r: 4.041,
    className: "prefix__cls-2",
    "data-name": "Ellipse 14",
    transform: "translate(2.523)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictoOffice);
export default __webpack_public_path__ + "static/media/picto-office.535dc62bc7d39db9539397de24e98e3c.svg";
export { ForwardRef as ReactComponent };